export type PayuTab = 'connect' | 'payments' | 'links' | 'refunds';

export const PAYU_TABS: readonly PayuTab[] = [
  'connect',
  'payments',
  'links',
  'refunds',
] as const;

export function resolveTabFromUrl(raw: string | null | undefined): PayuTab {
  if (!raw) return 'connect';
  return (PAYU_TABS as readonly string[]).includes(raw) ? (raw as PayuTab) : 'connect';
}

export function tabToSearchParams(
  prev: URLSearchParams,
  next: PayuTab
): URLSearchParams {
  const params = new URLSearchParams(prev);
  if (next === 'connect') {
    params.delete('tab');
  } else {
    params.set('tab', next);
  }
  return params;
}

export function buildPayuTabUrl(tab: PayuTab): string {
  if (tab === 'connect') return '/home/payu';
  return `/home/payu?tab=${tab}`;
}
